export default __webpack_public_path__ + "static/media/15.7812d410.png";